var _circle, _path, _stop, _stop2, _stop3, _stop4, _stop5, _stop6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgCoinPraise = function SvgCoinPraise(props) {
  var _id3 = useUniqueInlineId();
  var _id2 = useUniqueInlineId();
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 7.90588,
    cy: 8.40588,
    r: 7.90588,
    fill: "url(#".concat(_id, ")")
  }), /*#__PURE__*/React.createElement("mask", {
    id: "coinPraise_svg__mask0_59_3532",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.90588,
    cy: 8.40588,
    r: 7.90588,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#coinPraise_svg__mask0_59_3532)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.238739
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.90585,
    cy: 8.40588,
    r: 5.64706,
    fill: "url(#".concat(_id2, ")")
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.90585,
    cy: 8.40588,
    r: 5.64706,
    fill: "url(#".concat(_id3, ")")
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.17714 5.80371C7.36766 6.02549 6.74924 6.08408 6.21927 6.0798L6.20324 6.07964C5.57517 6.07304 4.83744 5.91587 4.75223 5.90058L4.74985 5.90016C4.67924 5.88799 4.62316 5.90821 4.58454 5.95797L4.5812 5.96245C4.46996 6.11506 4.40747 6.20732 4.28027 6.45616L4.27417 6.46814C4.25188 6.51171 4.27095 6.58121 4.33761 6.60289L4.34224 6.6043C4.40469 6.62193 5.25279 6.86881 6.07411 6.8849L6.099 6.88534C7.08567 6.92488 7.75851 6.72757 7.96995 6.67314L7.97622 6.67154C8.17666 6.62045 8.91696 6.40664 9.75948 6.39507L9.78504 6.39478C10.73 6.38641 11.286 6.54726 11.3858 6.5641L11.3887 6.56457C11.459 6.5754 11.5136 6.55758 11.558 6.50329L11.5618 6.49855C11.6273 6.41445 11.7888 6.15663 11.8454 6.02179L11.8482 6.01505C11.8727 5.95447 11.8553 5.89549 11.7887 5.86749L11.7841 5.86564C11.5617 5.77971 10.872 5.60928 10.1846 5.58705L10.1637 5.58642C10.0869 5.58427 10.0041 5.58267 9.91594 5.5824L9.89175 5.58237C9.44032 5.58235 8.84979 5.61942 8.17714 5.80371ZM9.9453 7.35881C9.48714 7.35882 8.91908 7.38827 7.98659 7.62835L7.95823 7.63567C7.137 7.8595 6.53153 7.86406 6.00211 7.8471L5.9861 7.84659C5.40029 7.82732 4.61719 7.63724 4.53107 7.62129L4.52869 7.62086C4.45802 7.6087 4.40404 7.63421 4.36557 7.68438L4.36231 7.68873C4.25095 7.84145 4.20238 7.91474 4.07455 8.16743L4.0687 8.17903C4.04399 8.22665 4.06204 8.29244 4.12565 8.31763L4.13015 8.31932C4.22579 8.35316 5.053 8.61288 5.85878 8.65236L5.8832 8.65347C6.83685 8.72447 7.6037 8.53874 7.75292 8.5032L7.75725 8.50218C7.95918 8.45423 8.78017 8.22068 9.54268 8.18083L9.56579 8.17967C10.4003 8.14027 11.0963 8.28184 11.1808 8.29591L11.1832 8.29628C11.2662 8.30947 11.315 8.27637 11.347 8.23574L11.3494 8.2326C11.3915 8.17706 11.5765 7.88928 11.6406 7.72563L11.643 7.71939C11.6636 7.66512 11.6455 7.60406 11.5795 7.58011L11.5749 7.57849C11.1865 7.45205 10.5252 7.36081 9.96404 7.35884L9.94559 7.35881H9.9453ZM9.90778 9.07694C9.44793 9.07694 8.87693 9.11767 7.93916 9.36145C7.11794 9.58527 6.51172 9.58129 5.98228 9.56418L5.96627 9.56368C5.38045 9.5444 4.57734 9.3531 4.42773 9.31394L4.42343 9.31279C4.3541 9.29444 4.30269 9.32838 4.26435 9.37925L4.26149 9.38311C4.15011 9.53584 4.09725 9.60678 3.96921 9.85953L3.96343 9.87098C3.93877 9.91855 3.95714 9.97758 4.02068 10.0025L4.02527 10.0042C4.09798 10.0299 4.3858 10.124 4.67579 10.1905L4.68591 10.1928C4.82394 10.2242 5.17772 10.2734 5.33188 10.4455L5.33807 10.4526C5.40965 10.5371 5.49408 10.6389 5.42197 10.9317L5.41964 10.941C5.28243 11.4808 5.06013 11.5571 5.1988 11.7164L5.20313 11.7213C5.24901 11.7719 5.31316 11.7925 5.3851 11.794L5.3921 11.7941H5.39496C5.62367 11.7933 5.92582 11.6076 5.98146 11.5768L5.98324 11.5758C6.06257 11.5326 6.33862 11.3645 6.4752 11.2824L6.48149 11.2786C6.79508 11.0904 7.80456 10.2924 9.09958 10.0183L9.13893 10.0102C10.1848 9.79843 10.9952 9.99334 11.0591 10.004L11.0608 10.0043C11.1167 10.0121 11.1779 10.0004 11.2231 9.95176L11.2273 9.94707C11.2861 9.87914 11.489 9.55844 11.5418 9.41801L11.5438 9.41255C11.5637 9.35724 11.5516 9.2967 11.4828 9.27308L11.4782 9.27159C11.1361 9.16626 10.4491 9.07986 9.9405 9.07701L9.92485 9.07694H9.90778Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: -7.90588,
    y1: 4.85486,
    x2: 0.80384,
    y2: 20.6666,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7C5"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD66E"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id2,
    x1: 10.4168,
    y1: 3.58312,
    x2: 1.49994,
    y2: 8.99999,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7C00"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id3,
    x1: 8.7008,
    y1: 12.304,
    x2: 9.34687,
    y2: 3.69936,
    gradientUnits: "userSpaceOnUse"
  }, _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A0D",
    stopOpacity: 0.4
  })), _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500"
  })))));
};
export default SvgCoinPraise;